var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUploadTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2331_7310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 37.5L35 50L55 25M37.5 72.5C32.9037 72.5 28.3525 71.5947 24.1061 69.8358C19.8597 68.0769 16.0013 65.4988 12.7513 62.2487C9.50121 58.9987 6.92313 55.1403 5.16422 50.8939C3.4053 46.6475 2.5 42.0963 2.5 37.5C2.5 32.9037 3.4053 28.3525 5.16422 24.1061C6.92313 19.8597 9.50121 16.0013 12.7513 12.7513C16.0013 9.50121 19.8597 6.92313 24.1061 5.16422C28.3525 3.4053 32.9037 2.5 37.5 2.5C46.7826 2.5 55.685 6.18749 62.2487 12.7513C68.8125 19.315 72.5 28.2174 72.5 37.5C72.5 46.7826 68.8125 55.685 62.2487 62.2487C55.685 68.8125 46.7826 72.5 37.5 72.5Z",
    stroke: "#7B31B2",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2331_7310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadTick);
export default __webpack_public_path__ + "static/media/uploadTick.40d8bb0282e923f7c5e1f8db16307e05.svg";
export { ForwardRef as ReactComponent };